import $ from 'jquery';
import Alert from 'src/alert'

export default class AxlesLoads {
  constructor(options = {}) {
    this._vehicle         = App.vehicles.filter(vehicle => vehicle.id === options.vehicleId)[0];
    this._vehicleSelector = `#vehicle-${this.vehicle.id}`;

    if (!Number.isFinite(this.vehicle.data.totalWeight)) {
      const loads = this.vehicle.data.loads && this.vehicle.data.loads.length ? this.vehicle.data.loads : [];
      this.vehicle.data.totalWeight = this.sumLoads(loads);
    }

    this.initAxlesLoads();
    this.initSpacings();

    $(document).on('click', `${this.vehicleSelector} [data-behavior~=reset-loads]`, () => {
      this.vehicle.data.loads = this.vehicle.data.defaultLoads;
      this.updateLoadInputs(this.loadInputs(), this.vehicle.data.loads);
      this.updateStoredTotalWeight(this.sumLoads(this.vehicle.data.loads));
      this.updateTotalWeightInput(this.totalWeight);

      return this.broadcastEvent('axlesLoadsChanged');
    });
  }

  get vehicle() {
    return this._vehicle;
  }

  get vehicleSelector() {
    return this._vehicleSelector;
  }

  get totalWeight() {
    const loads = this.vehicle.data.loads && this.vehicle.data.loads.length ?
      this.vehicle.data.loads
    :
      this.loadInputs().serializeArray().map(el => el.value);

    return Number.isFinite(this.vehicle.data.totalWeight) ?
      this.vehicle.data.totalWeight
    :
      this.sumLoads(loads);
  }

  broadcastEvent(type) {
    const event = new CustomEvent(type, {
      'detail': {
        'vehicleId': this.vehicle.id
      }
    });

    document.dispatchEvent(event);
  }

  initAxlesLoads() {
    $(document).off('focusin', `${this.vehicleSelector} [data-behavior~=axles-loads]`);
    $(document).off('change', `${this.vehicleSelector} [data-behavior~=axles-loads]`);
    $(document).off('click',  `${this.vehicleSelector} [data-behavior~=freeze-load]`);

    $(document).on('focusin', `${this.vehicleSelector} [data-behavior~=axles-loads]`, (event) => {
      $(event.target).data('val', $(event.target).val());
    });

    $(document).on('change', `${this.vehicleSelector} [data-behavior~=axles-loads]`, (event) => { this.distributeLoads(event.target); });
    $(document).on('click', `${this.vehicleSelector} [data-behavior~=freeze-load]`, (event) => { this.toggleLoadFreeze(event.target); });
  }

  initSpacings() {
    $(document).off('change', `${this.vehicleSelector} [data-behavior~=axles-spacings]`);

    $(document).on('change', `${this.vehicleSelector} [data-behavior~=axles-spacings]`, () => {
      this.vehicle.data.spacing = $(`${this.vehicleSelector} [data-behavior~=axles-spacings]`).serializeArray().map(el => el.value);

      this.broadcastEvent('axlesSpacingsChanged');
    });
  }

  loadInputs() {
    return $(`${this.vehicleSelector} [data-behavior~=axles-loads]`);
  }

  totalWeightInput() {
    return $(`${this.vehicleSelector} [data-behavior~=total-weight]`).first();
  }

  parseLoad(loadStr) {
    if (loadStr.match(/(kg|kilo|kilgram|kilogramm|killogramm|kilo)s?/)) {
      return Math.round((loadStr.replace(/\D/g, '') * 2.2));
    } else {
      return Number(loadStr.replace(/\D/g, ''));
    }
  }

  formatLoad(load) {
    return `${Math.round(load).toLocaleString()} lbs`;
  }

  sumLoads(loads) {
    return loads.reduce((acc, load) => acc + this.parseLoad(load), 0);
  }

  updateLoadInputs($loadInputs, loads) {
    $loadInputs.each((index, el) => {
      const load = loads[index];
      el.value   = typeof load === 'string' ? this.formatLoad(this.parseLoad(load)) : this.formatLoad(load);
    });
  }

  updateStoredTotalWeight(weight) {
    if (!Number.isFinite(weight)) { return; }

    this.vehicle.data.totalWeight = Math.round(weight);
  }

  updateTotalWeightInput(weight) {
    const $totalWeightInput = this.totalWeightInput();

    if (!$totalWeightInput.length || !Number.isFinite(weight)) { return; }

    $totalWeightInput.val(this.formatLoad(weight));
  }

  distributeEvenly(totalWeight, count) {
    const baseWeight = Math.floor(totalWeight / count);
    const remainder  = totalWeight - (baseWeight * count);

    return Array.from({ length: count }, (_, index) => (
      index === count - 1 ? baseWeight + remainder : baseWeight
    ));
  }

  setTotalWeight(totalWeight) {
    const $loadInputs    = this.loadInputs();
    const $frozenInputs  = $loadInputs.filter("[readonly='readonly']");
    const $editableInputs = $loadInputs.not($frozenInputs);
    const nextTotalWeight = Math.round(totalWeight);
    const lockedTotal     = this.sumLoads($frozenInputs.map((_, el) => el.value).toArray());
    const previousTotal   = this.totalWeight;
    const errorMessage    = 'Total weight must be at least the sum of frozen axle loads.';

    if (lockedTotal > nextTotalWeight) {
      this.updateStoredTotalWeight(previousTotal);
      this.updateTotalWeightInput(previousTotal);
      Alert.show(errorMessage, 'danger');
      return false;
    }

    if (!$editableInputs.length) {
      if (lockedTotal !== nextTotalWeight) {
        this.updateStoredTotalWeight(previousTotal);
        this.updateTotalWeightInput(previousTotal);
        Alert.show(errorMessage, 'danger');
        return false;
      }

      this.updateStoredTotalWeight(nextTotalWeight);
      this.updateTotalWeightInput(nextTotalWeight);
      return true;
    }

    const distributedWeights = this.distributeEvenly(nextTotalWeight - lockedTotal, $editableInputs.length);

    $editableInputs.each((index, el) => {
      el.value = this.formatLoad(distributedWeights[index]);
    });

    this.vehicle.data.loads        = $loadInputs.serializeArray().map(el => el.value);
    this.vehicle.data.defaultLoads = [...this.vehicle.data.loads];
    this.updateStoredTotalWeight(this.sumLoads(this.vehicle.data.loads));
    this.updateTotalWeightInput(this.totalWeight);
    this.broadcastEvent('axlesLoadsChanged');

    return true;
  }

  distributeLoads(context) {
    const $el                = $(context);
    const $loadInputs        = this.loadInputs();
    const $freezedInputs     = $loadInputs.filter("[readonly='readonly']");
    const $distributedInputs = $loadInputs.not($freezedInputs).not($el);

    const load        = this.parseLoad($el.val());
    const totalWeight = this.totalWeight;

    const freezedWeight = $freezedInputs
                    .map((_, el) => el.value)
                    .toArray()
                    .reduce(((acc, frozenLoad) => acc + this.parseLoad(frozenLoad)), 0);

    if (!$distributedInputs.length) {
      const remainingWeight = totalWeight - freezedWeight;

      if (load > remainingWeight) {
        $el.val($el.data('val'));
        Alert.show(`${this.formatLoad(load)} is too large. Reduce it or increase total weight`, 'danger');
        return;
      }

      $el.val(this.formatLoad(remainingWeight));
      this.vehicle.data.loads = $loadInputs.serializeArray().map(el => el.value);
      this.updateStoredTotalWeight(this.sumLoads(this.vehicle.data.loads));
      this.updateTotalWeightInput(this.totalWeight);
      this.broadcastEvent('axlesLoadsChanged');
      return;
    }

    const distributedWeight = totalWeight - freezedWeight - load;

    if (distributedWeight < 0) {
      $el.val($el.data('val'));
      Alert.show(`${this.formatLoad(load)} is too large. Reduce it or increase total weight`, 'danger');
      return;
    }

    $el.val(this.formatLoad(load));

    this.distributeEvenly(distributedWeight, $distributedInputs.length).forEach((weight, index) => {
      $distributedInputs[index].value = this.formatLoad(weight);
    });

    this.vehicle.data.loads = $loadInputs.serializeArray().map(el => el.value);
    this.updateStoredTotalWeight(this.sumLoads(this.vehicle.data.loads));
    this.updateTotalWeightInput(this.totalWeight);

    this.broadcastEvent('axlesLoadsChanged');
  }

  toggleLoadFreeze(context) {
    const $el = $(context);

    $el.parent().next().attr('readonly', (_, v) => !v);
  }
};
